

export default {
    data (){
        return {

        }
    },
    computed: {

    },
    mounted(){

    },
    methods: {
        
    },
    watch: {
        
    }
}
